<div class="page-title">
  <div class="title" [innerHTML]="'SubstituteInfo.First.Title' | translate"></div>
  <div class="sub-title" [innerHTML]="'SubstituteInfo.First.SubTitle' | translate"></div>
</div>

<app-substitute
  [signatureModel]="user.signatureModel"
  [personalInfo]="user"
  [addressInfo]="user.addressModel"
  [citizenshipInfo]="user.contactModel"
  (userModelChange)="updateUser()"
>
</app-substitute>
